import { getAuthHeaders } from './auth';
import { enrichPopularComponent } from './popularCatalogDetails';
async function request(path, body, method='GET') {
 const r=await fetch(path,{method,headers:{...getAuthHeaders(),'Content-Type':'application/json'},body:body?JSON.stringify(body):undefined});
 const d=await r.json().catch(()=>({}));
 if(!r.ok)throw new Error(typeof d.detail==='string'?d.detail:d.message||`Ошибка поиска: ${r.status}`);
 return d;
}
export const searchCatalog=body=>request('/api/catalog-search/search',body,'POST');
export const catalogSettings=()=>request('/api/catalog-search/settings');
export const catalogStatus=()=>request('/api/catalog-search/status');
export const catalogDictionary=()=>request('/api/catalog-search/dictionary');
let popularCache = null;
const detailCache = new Map();
export const popularCatalogComponents=async()=>{
 const session=getAuthHeaders().Authorization || '';
 if(popularCache?.session===session && Date.now()-popularCache.created<60000)return popularCache.items;
 const rows=await request('/api/catalog-search/popular');
 const items=Array.isArray(rows)?rows.slice(0,10):[];
 popularCache={session,created:Date.now(),items};
 return items;
};
export const popularCatalogDetails=async(item)=>{
 const session=getAuthHeaders().Authorization || '';
 const key=JSON.stringify([session,item.part_number,item.manufacturer || '']);
 const cached=detailCache.get(key);
 if(cached && Date.now()-cached.created<60000)return cached.promise;
 if(detailCache.size>100)detailCache.clear();
 const promise=enrichPopularComponent(item,searchCatalog);
 detailCache.set(key,{created:Date.now(),promise});
 return promise;
};
export const saveCatalogSettings=body=>request('/api/admin/catalog-search/settings',body,'PUT');
export const catalogTranslations=offset=>request(`/api/admin/catalog-search/translations?offset=${offset}`);
export const saveCatalogTranslation=body=>request('/api/admin/catalog-search/translations',body,'PUT');
export const catalogTaxonomy=()=>request('/api/admin/catalog-search/taxonomy');
export const saveCatalogTaxonomyImage=(nodeId,imageData)=>request(`/api/admin/catalog-search/taxonomy/images/${nodeId}`,{image_data:imageData},'PUT');
export async function catalogTaxonomyImage(imageUrl){
 const response=await fetch(imageUrl,{headers:getAuthHeaders()});
 if(!response.ok)throw new Error(response.status===404?'Фото категории не найдено':'Не удалось загрузить фото категории');
 return URL.createObjectURL(await response.blob());
}
export const automapCatalogTaxonomy=limit=>request('/api/admin/catalog-search/taxonomy/automap',{limit},'POST');
export const saveCatalogTaxonomyMapping=body=>request('/api/admin/catalog-search/taxonomy/mappings',body,'PUT');

export const catalogManufacturers=()=>request('/api/admin/catalog-search/manufacturers');
export const automapCatalogManufacturers=limit=>request('/api/admin/catalog-search/manufacturers/automap',{limit},'POST');
export const saveManufacturerMapping=body=>request('/api/admin/catalog-search/manufacturers/mappings',body,'PUT');

export const catalogCard=id=>request('/api/components/assets/card?id='+encodeURIComponent(id));

export const categoryProperties=nodeId=>request(`/api/admin/catalog-search/taxonomy/${nodeId}/properties`);
export const saveCategoryProperty=(nodeId,body)=>request(`/api/admin/catalog-search/taxonomy/${nodeId}/properties`,body,'PUT');
export const removeCategoryProperty=(nodeId,code)=>request(`/api/admin/catalog-search/taxonomy/${nodeId}/properties/${encodeURIComponent(code)}/remove`,{},'POST');
export const reparseCategory=nodeId=>request(`/api/admin/catalog-search/taxonomy/${nodeId}/reparse`,{},'POST');
export const productCharacteristics=id=>request(`/api/admin/catalog-search/products/${encodeURIComponent(id)}/characteristics`);
export const saveProductCharacteristic=async(id,code,body)=>{
 const result=await request(`/api/admin/catalog-search/products/${encodeURIComponent(id)}/characteristics/${encodeURIComponent(code)}`,body,'PUT');
 popularCache=null;detailCache.clear();return result;
};
export const annotationOverview=()=>request('/api/admin/catalog-search/annotation/overview');
export const characteristicDictionary=params=>request('/api/admin/catalog-search/characteristic-dictionary?'+new URLSearchParams(params||{}));
export const saveCanonicalProperty=body=>request('/api/admin/catalog-search/characteristic-dictionary/properties',body,'PUT');
export const saveCanonicalValue=body=>request('/api/admin/catalog-search/characteristic-dictionary/values',body,'PUT');
export const decideCharacteristicMapping=(id,body)=>request(`/api/admin/catalog-search/characteristic-dictionary/mappings/${id}`,body,'PUT');
export const proposeCharacteristicMappings=()=>request('/api/admin/catalog-search/characteristic-dictionary/propose',{},'POST');
export const characteristicEnrichment=params=>request('/api/admin/catalog-search/characteristic-enrichment?'+new URLSearchParams(params||{}));
export const characteristicEnrichmentControl=()=>request('/api/admin/catalog-search/characteristic-enrichment/control');
export const saveCharacteristicEnrichmentControl=paused=>request('/api/admin/catalog-search/characteristic-enrichment/control',{paused},'PUT');
export const enqueueCharacteristicEnrichment=id=>request(`/api/admin/catalog-search/characteristic-enrichment/products/${encodeURIComponent(id)}`,{},'POST');
export const decideCharacteristicEnrichment=(id,action)=>request(`/api/admin/catalog-search/characteristic-enrichment/${id}`,{action},'PUT');
export const retryProductCharacteristicEnrichment=(productId,id)=>request(`/api/admin/catalog-search/characteristic-enrichment/products/${encodeURIComponent(productId)}/${id}`,{action:'retry'},'PUT');

export const saveProductCategory=(id,body)=>request(`/api/admin/catalog-search/products/${encodeURIComponent(id)}/annotation-category`,body,'PUT');

export const confirmCharacteristicCard=(id,fingerprint)=>request(`/api/admin/catalog-search/products/${encodeURIComponent(id)}/characteristic-review`,{fingerprint},'POST');

export const requestSupplierCharacteristics=(productId,supplier)=>request(`/api/admin/material-downloads/characteristics/products/${encodeURIComponent(productId)}`,{supplier},'POST');
export const supplierCharacteristicsProgress=(productId,supplier)=>request(`/api/admin/material-downloads/characteristics/products/${encodeURIComponent(productId)}?`+new URLSearchParams({supplier}));
